<template>
  <div class="delivery-condition-select">
    <!-- 伪输入，展示区 -->
    <div :class="[{'fake-input-active': isIdsSelectShow}, 'fake-input']" @click="fakeInputClickHandler">
      <div class="fake-input-placeholder" v-if="!idsSelectValueString">{{ $bp_t('请选择', 'common.please_choose') }}</div>
      <div class="fake-input-value">{{idsSelectValueString}}</div>
      <div class="fake-input-btn">{{ $bp_t('选择', 'common.choice') }}</div>
    </div>
    <!-- 弹窗，实际输入区 -->
    <byted-modal
      v-model="isIdsSelectShow"
      title="选择投放条件"
      :mask-closable="false"
      class="dialog-ids-select"
      ref="dialog-ids-select"
    >
      <div slot="body">
        <div class="ids-select-content">
          <!-- 搜索 -->
          <div class="search-area" v-byted-clickoutside="searchClickOutsideHandler">
            <byted-input
              v-model="searchInput"
              placeholder="请输入名称或ID搜索"
              @keyup="searchInputChangeHandler"
              @focus="inputFocusHandler"
            >
              <template slot="prepend">
                <byted-select
                  class="option-select"
                  v-model="selectedOption"
                  @change="selectChangeHandler"
                >
                  <byted-option
                    v-for="option in idsSelectOptionList"
                    :value="option.value"
                    :key="option.label"
                  >
                    {{option.label}}
                  </byted-option>
                </byted-select>
              </template>
            </byted-input>
            <!-- 搜索结果 -->
            <div class="search-result"
              v-byted-loading="isSearchLoading" 
              v-if="isSearchResultShow && searchInput">
              <template v-if="searchResult.length">
                <div
                  class="search-item"
                  v-for="(item, index) in searchResult"
                  :key="index"
                  @click.stop="searchResultItemClickHandler(item)"
                >
                  <div class="search-label">{{item.label}}</div>
                </div>
              </template>
              <template v-else>
                <div class="search-item-empty">
                  <byted-icon name="empty" color="#D6D6D6" width="37px" height="37px"></byted-icon>
                  <div class="no-data">暂无数据</div>
                </div>
              </template>
            </div>
          </div>
          <!-- 选项 -->
          <div
            class="select-ids-panel"
            v-byted-loading="isSelectPanelLoading"
            data-no-translate
          >
            <byted-select-panel
              :title="idsSelectOptionList.map(option => option.label)"
              :options="panelOptions"
              v-model="selectedIds"
              :auto-scroll="true"
              list-width="198px"
              ref="report-selected"
            ></byted-select-panel>
          </div>
        </div>
      </div>
      <template slot="footer">
        <byted-button type="default" @click="cancelBtnHandler">{{ $bp_t('取消', 'common.cancel') }}</byted-button>
        <byted-button type="info" @click="applyBtnHandler">{{ $bp_t('应用', 'common.application') }}</byted-button>
      </template>
    </byted-modal>
  </div>
</template>

<script>
import Apis from 'Src/const/apis'

const OPTION_CAR_TYPE = 'car_model'
const OPTION_DELIVERY_CONDITION = 'delivery_condition'
const MIDDLE_PREFIX = '_'
const SEARCH_TYPE = {
  [OPTION_CAR_TYPE]: 2, // 车型
  [OPTION_DELIVERY_CONDITION]: 1 //投放条件
}
const idsSelectOptionList = [
  {label: '车型', value: OPTION_CAR_TYPE, name: OPTION_CAR_TYPE},
  {label: '投放条件', value: OPTION_DELIVERY_CONDITION, name: OPTION_DELIVERY_CONDITION},
];
export default {
  name: 'delivery-condition-select',
  props: {
    value: {
      type: Object,
      default: () => ({
        car_delivery_condition_ids: [],
        selected_car_ids: [],
      })
    },
    carLibs: {
      type: Number | String,
      required: true,
    }
  },
  data() {
    return {
      isIdsSelectShow: false,
      isSearchResultShow: false,
      searchInput: '',
      searchResult: [],
      isSearchLoading: false,
      idsSelectOptionList: idsSelectOptionList,
      selectedOption: OPTION_DELIVERY_CONDITION,
      isSelectPanelLoading: false,
      panelOptions: [],
      selectedIds: [],
    }
  },
  computed: {
    idsSelectValueString() {
      const selectedCount = this.value.selected_car_ids.length;
      return selectedCount ? $bp_t(`已选${selectedCount}项`, 'common.selected_filter_term', { data: selectedCount }) : ''
    }
  },
  watch: {
    isIdsSelectShow(newVal) {
      // 关闭modal时直接返回
      if (!newVal) return;
      // 打开modal时设置默认数据
      this.searchInput = '';
      this.selectedIds = [...this.value.selected_car_ids];

      this.initCarType()
    }
  },
  mounted() {
    this.$refs['dialog-ids-select'].$el.addEventListener('click', (e) => {
      //  阻断冒泡
      e.cancelBubble = true
      e.stopPropagation && e.stopPropagation()
    })
  },
  methods: {
    fakeInputClickHandler() {
      this.isIdsSelectShow = true;
    },
    getData (options) {
      const { url, data } = options
      return new Promise((resolve, reject) => {
        return BUI.fetch({
          url,
          data,
          success: (resp) => {
            if (resp.code === 0) {
              resolve(resp)
            } else {
              this.$message(resp.msg || '系统错误', 'error')
              reject(resp)    //  eslint-disable-line
            }
          },
          error: function (error) {
            this.$message(error.msg || '系统错误', 'error')
            reject(error)     //  eslint-disable-line
          }
        })
      })
    },
    async initCarType () {
      this.panelOptions = []
      this.isSelectPanelLoading = true;
      const options = {
        url: Apis.reporter.car.car_delivery_condition,
        data: { car_platform_id: this.carLibs }
      }
      try {
        let { data: {cars = []} } = await this.getData(options)
        this.panelOptions = cars.map(car => {
          let carData = {
            id: `${OPTION_CAR_TYPE}_${car.car_model_id_str}`,
            originId: car.car_model_id_str,
            name: car.car_model_name,
            childrenLoaded: false,
            children: []
          }
          if (Array.isArray(car.conditions)) {
            car.conditions.map(condition => {
              carData.children.push({
                id: `${OPTION_DELIVERY_CONDITION}_${condition.delivery_condition_id_str}`,
                originId: condition.delivery_condition_id_str,
                name: condition.delivery_condition_name,
                children: false,
              })
            })
          }
          carData.renderName = (name, option) => {
            return (
              <byted-tooltip
                hideDelay={0}
                transfer
                placement='left'
                trigger='hover'
              >
                {name}
                <span slot='reference'>{name}</span>
              </byted-tooltip>
            )
          }
          return carData;
        })
        this.isSelectPanelLoading = false;
      } catch (e) {
        this.isSelectPanelLoading = false;
      }
    },
    searchClickOutsideHandler() {
      this.isSearchResultShow = false;
    },
    searchInputChangeHandler: _.debounce(function () {
      this.search();
    }, 500),
    async search () {
      if (!this.searchInput) {
        return
      }
      this.searchResult = []
      this.isSearchResultShow = true
      this.isSearchLoading = true
      try {
        const options = {
          data: {
            car_platform_id: this.carLibs,
            search_type: SEARCH_TYPE[this.selectedOption],
            keyword: this.searchInput
          },
          url: Apis.reporter.car.car_delivery_condition
        }
        const {
          data: { cars = [] }
        } = await this.getData(options)
        const suggestList = []
        if (this.selectedOption === OPTION_CAR_TYPE) {
          // 选择的为车型，把车型筛选出
          cars.map(car => {
            suggestList.push({
              car_model_id_str: car.car_model_id_str,
              car_model_name: car.car_model_name
            })
          })
        } else if (this.selectedOption === OPTION_DELIVERY_CONDITION) {
          // 选择的为投放条件
          cars.map(car => {
            car.conditions.map(condition => {
              suggestList.push({
                ...condition,
                car_model_id_str: car.car_model_id_str
              })
            })
          })
        }
        if (suggestList.length <= 0) {
          this.isSearchLoading = false
          return
        }
        this.searchResult = suggestList.map(item => {
          return {
            ...item,
            label: item[`${this.selectedOption}_name`]
          }
        })
        this.isSearchLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    async searchResultItemClickHandler(item) {
      this.isSearchResultShow = false;
      // 车型
      const carId = item[`${OPTION_CAR_TYPE}_id_str`];
      const carItem = `${OPTION_CAR_TYPE}_${carId}`;
      if (this.selectedOption === OPTION_CAR_TYPE) {
        this.$refs['report-selected'].focusItem([carItem]);
        this.selectedIds = Array.from(new Set([...this.selectedIds, carItem]));
      }
      // 投放计划
      const deliveryId = item[`${OPTION_DELIVERY_CONDITION}_id_str`];
      const deliveryItem = `${OPTION_DELIVERY_CONDITION}_${deliveryItem}`;
      if (this.selectedOption === OPTION_DELIVERY_CONDITION) {
        this.$refs['report-selected'].focusItem([deliveryItem]);
        this.selectedIds = Array.from(new Set([...this.selectedIds, deliveryItem]));
      }
    },
    inputFocusHandler() {
      this.search();
    },
    selectChangeHandler() {
      this.search();
    },
    cancelBtnHandler() {
      this.isIdsSelectShow = false;
    },
    applyBtnHandler() {
      this.selectedIdsClassification()
      this.isIdsSelectShow = false;
    },
    selectedIdsClassification() {
      const selectedIds = this.selectedIds;
      const deliveryConditions = [];
      selectedIds.map(id => {
        const isCarType = id.includes(OPTION_CAR_TYPE);
        const isDeliveryCondition = id.includes(OPTION_DELIVERY_CONDITION);
        const realId = id.split('_')[id.split('_').length - 1];
        // 车型
        if (isCarType) {
          this.panelOptions.map(car => {
            if (car.id === id) {
              car.children.map(condition => {
                if (condition && condition.originId) {
                  deliveryConditions.push(condition.originId)
                }
              })
            }
          })
        }
        // 投放条件
        else if (isDeliveryCondition) {
          realId && deliveryConditions.push(realId)
        }
      })
      this.$emit('valueChanged', {car_delivery_condition_ids: deliveryConditions, selected_car_ids: selectedIds})
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/basic/theme.scss";

.fake-input {
  height: 34px;
  width: 210px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  position: relative;

  .fake-input-placeholder {
    color: $color-text-holder;
  }

  .fake-input-value {
    color: $color-border-underline;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .fake-input-btn {
    cursor: pointer;
    color: $color-active-light;
    font-size: 14px;
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

   &:hover {
    border-color: #2f88ff !important;
  }

  &.fake-input-active {
    border-color: #2f88ff !important;
    box-shadow: 0 0 0 2px rgba(47, 136, 255, 0.2);
  }
}

.dialog-ids-select {
  .bui-modal-dialog {
    width: 662px;
  }
  .ids-select-content {
    .search-area {
      width: 400px;
      position: relative;
      .byted-icon {
        vertical-align: middle;
      }
      .option-select {
        width: 104px;
      }
      .search-result {
        font-size: 14px;
        width: 295px;
        max-height: 192px;
        overflow-y: auto;
        background-color: $color-bg-container;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        z-index: 10;
        position: absolute;
        top: 40px;
        left: 104px;
        padding: 6px 0;
        .search-item {
          cursor: pointer;
          width: 100%;
          padding: 6px 12px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &:hover {
            background-color: $color-bg-block;
          }
          .search-high-light {
            color: $color-text-link;
          }
          .search-label {
            line-height: 22px;
            display: block;
            cursor: pointer;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #333;
          }
        }
        .search-item-empty {
          width: 100%;
          padding: 62px 12px;
          line-height: 22px;
          text-align: center;
          .no-data {
            font-size: 14px;
            color: #C1C1C1;
            line-height: 22px;
            margin-top: 9px;
          }
        }
      }
    }
    .select-ids-panel {
      margin-top: 16px;
    }
    .byted-popover-wrapper {
      display: block;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>